import { getPluginSelector } from 'reducers/Plugins';

import { IS_ONLINE_RETURN, IS_CFR_RETURN } from './actionTypes';

export interface CFRState {
  isOnlineReturn: boolean;
  isCFRReturn: boolean;
}

const initState = {
  isOnlineReturn: false,
  isCFRReturn: false,
};

const CFRReducer = (
  state = initState,
  { type, payload }: { type: string; payload: any },
): CFRState => {
  switch (type) {
    case IS_ONLINE_RETURN:
      return { ...state, isOnlineReturn: payload };
    case IS_CFR_RETURN:
      return { ...state, isCFRReturn: payload };
    default:
      return state;
  }
};

export const getCFRState = state =>
  getPluginSelector<CFRState>('CFR')(n => n)(state);

export const getISCFRReturn = state => {
  const { isCFRReturn } = getCFRState(state);
  return isCFRReturn;
};

export default CFRReducer;
